<template>
	<div class="frequent-questions" v-if="shouldShow">
		<!-- 悬浮收缩框 -->
		<div
			class="floating-container"
			:class="{collapsed: isCollapsed}"
			@mouseenter="showContent"
			@mouseleave="hideContent">
			<!-- 主体内容 -->
			<div class="question-content" v-if="!isCollapsed">
				<div class="question-header">
					<i class="el-icon-question"></i>
					<span class="question-title">常见问题</span>
				</div>
				<div class="question-body">
					<p class="question-text">遇到问题了？</p>
					<p class="question-text">点击查看帮助文档</p>
					<el-button type="primary" size="small" @click="handleClick">查看帮助</el-button>
				</div>
			</div>

			<!-- 收缩状态 -->
			<div class="collapsed-content" v-else>
				<i class="el-icon-question"></i>
				<span class="collapsed-text">常见问题</span>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
const sensors = require('sa-sdk-javascript')

export default {
	name: 'FrequentQuestions',
	data() {
		return {
			isCollapsed: true, // 默认为收缩状态
		}
	},
	computed: {
		...mapGetters(['menu']),

		// 检查用户是否拥有相关权限
		shouldShow() {
			return this.hasWikiPermission || this.hasWikiopPermission
		},

		// 检查是否有 /wiki/index 权限
		hasWikiPermission() {
			return this.checkMenuPermission('/wiki/index')
		},

		// 检查是否有 /wikiop/index 权限
		hasWikiopPermission() {
			return this.checkMenuPermission('/wikiop/index')
		},
	},
	methods: {
		// 递归检查菜单权限
		checkMenuPermission(targetPath) {
			if (!this.menu || !Array.isArray(this.menu)) {
				return false
			}

			const checkPath = (menuItems) => {
				for (const item of menuItems) {
					// 检查当前菜单项的路径
					if (item.path === targetPath) {
						return true
					}

					// 递归检查子菜单
					if (item.children && Array.isArray(item.children)) {
						if (checkPath(item.children)) {
							return true
						}
					}
				}
				return false
			}

			return checkPath(this.menu)
		},

		// 鼠标悬浮显示内容
		showContent() {
			this.isCollapsed = false
		},

		// 鼠标离开隐藏内容
		hideContent() {
			this.isCollapsed = true
		},

		// 处理点击事件
		handleClick() {
			let route = this.hasWikiopPermission ? '/wikiop/index' : '/wiki/index'
			sensors.track('ie_help_tool_entry_click', {
				questionsUrl: route,
				button_name: '查看帮助',
			})
			this.$router.push(route)
		},
	},
}
</script>

<style scoped lang="scss">
.frequent-questions {
	position: fixed;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	z-index: 1000;
	font-family: 'Microsoft YaHei', sans-serif;
}

.floating-container {
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	transition: all 0.3s ease;
	overflow: hidden;

	&.collapsed {
		border-radius: 20px;
	}
}

.question-content {
	width: 200px;
	padding: 16px;
}

.question-header {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	color: #409eff;

	.el-icon-question {
		font-size: 18px;
		margin-right: 8px;
	}

	.question-title {
		font-size: 14px;
		font-weight: 500;
		flex: 1;
	}
}

.question-body {
	text-align: center;

	.question-text {
		margin: 0 0 8px 0;
		font-size: 12px;
		color: #666;
		line-height: 1.4;
	}

	.el-button {
		margin-top: 8px;
		width: 100%;
	}
}

.collapsed-content {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 12px 8px;
	color: #409eff;
	transition: all 0.3s ease;

	&:hover {
		background: #f5f7fa;
	}

	.el-icon-question {
		font-size: 20px;
		margin-bottom: 4px;
	}

	.collapsed-text {
		font-size: 11px;
		writing-mode: vertical-lr;
		text-orientation: upright;
		letter-spacing: 2px;
	}
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
	.frequent-questions {
		right: 10px;
	}

	.question-content {
		width: 180px;
		padding: 12px;
	}

	.question-header .question-title {
		font-size: 13px;
	}

	.question-body .question-text {
		font-size: 11px;
	}
}
</style>
